import React, { Component } from 'react';
import { TextField } from '@mui/material';
import ResultLinksBreadcrumb from './resultLinksBreadcrumb';
import DateRangeFilter from '../../../common/DateRangeFilter';

class ResultLinksSearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <ResultLinksBreadcrumb />
                <div className="row mt-1 d-flex align-items-center" style={{ padding: '12px' }}>
                    <div className="col-md-8">
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <DateRangeFilter
                                            date_range={this.props.date_range}
                                            from_date={this.props.from_date}
                                            to_date={this.props.to_date}
                                            updateDateRange={this.props.updateDateRange}
                                            handleDateFiltersChange={this.props.handleDateFiltersChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 text-right">
                        <TextField
                            label="Current Grid Search"
                            variant="outlined"
                            id="reset-form"
                            className="mt-2"
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="none"
                            onChange={this.props.onFilterTextChange}
                        />
                        <button className="btn btn-primary button-info-grid" onClick={() => this.props.clearFilter()}>
                            <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ResultLinksSearchMenu;
